import api from './axios';

/**
 * Service Types API
 * Manages service type definitions with custom field schemas
 */
const serviceTypeRequest = {
    /**
     * Get all active service types
     * @returns {Promise} List of service types with custom_fields_schema
     */
    getAll() {
        return api.get('/service-type');
    },

    /**
     * Get service type by ID
     * @param {number} id - Service type ID
     * @returns {Promise} Service type with custom_fields_schema
     */
    getById(id) {
        return api.get(`/service-type/${id}`);
    },

    /**
     * Get service type by slug
     * @param {string} slug - Service type slug (e.g., 'transportation')
     * @returns {Promise} Service type with custom_fields_schema
     */
    getBySlug(slug) {
        return api.get(`/service-type/slug/${slug}`);
    },

    /**
     * Get only the custom fields schema for a service type
     * @param {number} id - Service type ID
     * @returns {Promise} Custom fields schema array
     */
    getSchema(id) {
        return api.get(`/service-type/${id}/schema`);
    },

    /**
     * Create a new service type (admin only)
     * @param {Object} data - Service type data
     * @param {string} data.name - Display name
     * @param {string} data.slug - URL-friendly identifier
     * @param {string} data.description - Description
     * @param {boolean} data.is_active - Active status
     * @param {Array} data.custom_fields_schema - Field definitions
     * @returns {Promise} Created service type
     */
    create(data) {
        const payload = { ...data };
        delete payload.created_by;
        delete payload.updated_by;
        return api.post('/service-type', payload, { orgContext: 'global' });
    },

    /**
     * Update a service type (admin only)
     * @param {number} id - Service type ID
     * @param {Object} data - Updated service type data
     * @returns {Promise} Updated service type
     */
    update(id, data) {
        const payload = { ...data };
        delete payload.created_by;
        delete payload.updated_by;
        return api.patch(`/service-type/${id}`, payload, { orgContext: 'global' });
    },

    /**
     * Soft delete a service type (admin only)
     * @param {number} id - Service type ID
     * @returns {Promise} Deletion confirmation
     */
    delete(id) {
        return api.delete(`/service-type/${id}`, { orgContext: 'global' });
    }
};

export default serviceTypeRequest;
